import {useRouteMatch} from "react-router";

import {kmAppPath, SiteSlug} from "@pg-mono/km-routes";

import {ghRedirectUrl, rpRedirectUrl} from "@/features/km_app/utils/read_environment_variables";

const logoGH = require("../features/km_app/images/logo_gh_default.png");
const logoRP = require("../features/km_app/images/logo_rp_default.svg");

/** Display height shared by mobile header and desktop sidebar (Figma). */
const NAV_LOGO_HEIGHT = "40";

/** Intrinsic sizes at NAV_LOGO_HEIGHT — keeps Image box aspect in sync with the asset (avoids letterbox gap). */
const logoRPSize = {height: NAV_LOGO_HEIGHT, width: String(Math.round((196 / 60) * Number(NAV_LOGO_HEIGHT)))} as const; // viewBox 196×60
// Matched to logoRPSize.width (not NAV_LOGO_HEIGHT) — PNG 175×40 is wider than the RP logo at the same height,
const logoGHSize = {height: String(Math.round((40 / 175) * Number(logoRPSize.width))), width: logoRPSize.width} as const;

export const useRefererData = (forceSite?: SiteSlug) => {
    const currentSite = forceSite || useRouteMatch<{site: string}>(kmAppPath.site.base)?.params.site;

    switch (currentSite) {
        case SiteSlug.GH: {
            return {
                logo: logoGH,
                logoSize: logoGHSize,
                redirectUrl: ghRedirectUrl,
                slug: SiteSlug.GH
            };
        }
        case SiteSlug.RP: {
            return {
                logo: logoRP,
                logoSize: logoRPSize,
                redirectUrl: rpRedirectUrl,
                slug: SiteSlug.RP
            };
        }
        default: {
            return {
                logo: logoRP,
                logoSize: logoRPSize,
                redirectUrl: rpRedirectUrl,
                slug: SiteSlug.KM
            };
        }
    }
};
import {useRouteMatch} from "react-router";

import {kmAppPath, SiteSlug} from "@pg-mono/km-routes";

import {ghRedirectUrl, rpRedirectUrl} from "@/features/km_app/utils/read_environment_variables";

const logoGH = require("../features/km_app/images/logo_gh_default.png");
const logoRP = require("../features/km_app/images/logo_rp_default.svg");

/** Display height shared by mobile header and desktop sidebar (Figma). */
const NAV_LOGO_HEIGHT = "40";

/** Intrinsic sizes at NAV_LOGO_HEIGHT — keeps Image box aspect in sync with the asset (avoids letterbox gap). */
const logoRPSize = {height: NAV_LOGO_HEIGHT, width: String(Math.round((196 / 60) * Number(NAV_LOGO_HEIGHT)))} as const; // viewBox 196×60
// Matched to logoRPSize.width (not NAV_LOGO_HEIGHT) — PNG 175×40 is wider than the RP logo at the same height,
const logoGHSize = {height: String(Math.round((40 / 175) * Number(logoRPSize.width))), width: logoRPSize.width} as const;

export const useRefererData = (forceSite?: SiteSlug) => {
    const currentSite = forceSite || useRouteMatch<{site: string}>(kmAppPath.site.base)?.params.site;

    switch (currentSite) {
        case SiteSlug.GH: {
            return {
                logo: logoGH,
                logoSize: logoGHSize,
                redirectUrl: ghRedirectUrl,
                slug: SiteSlug.GH
            };
        }
        case SiteSlug.RP: {
            return {
                logo: logoRP,
                logoSize: logoRPSize,
                redirectUrl: rpRedirectUrl,
                slug: SiteSlug.RP
            };
        }
        default: {
            return {
                logo: logoRP,
                logoSize: logoRPSize,
                redirectUrl: rpRedirectUrl,
                slug: SiteSlug.KM
            };
        }
    }
};
